import { useEffect, useState } from "react";
import { useDealer } from "../../../../../../../tools/api";
import { Table } from "antd";
import { NotFound } from "../../../../../../../sources/svg/svg";
import { convertCurrencyToToman, convertToJalaliWithTime, formatDate } from "../../../../../../../tools/tools";

const Packages = ({ purchase = {} }) => {
	const { queryEPPurchaseBySPPurchaseId } = useDealer();

	const [epState, setEPState] = useState({
		ListPackage: [],
		currentPage: 0,
		totalRecord: 0,
		isLoading: true,
	});

	useEffect(() => {
		const initial = async () => {
			try {
				//#region packages
				setEPState((ep) => ({ ...ep, isLoading: true }));
				const payloadPackage = {
					SPPurchaseId: purchase?.guD_PurchaseProductId,
					search: {
						sort: "",
						filter: "",
						entriesperpage: 10,
						page: epState?.currentPage === 0 ? 0 : epState?.currentPage - 1,
						totalrowcount: 0,
					},
				};
				const responsePackages = await queryEPPurchaseBySPPurchaseId(payloadPackage);
				if (responsePackages)
					setEPState((ep) => ({ ...ep, ListPackage: responsePackages.Result, totalRecord: responsePackages?.searchconfigmodel?.totalrowcount }));

				setEPState((ep) => ({ ...ep, isLoading: false }));
				//#endregion packages
			} catch (error) {
				setEPState((ep) => ({ ...ep, isLoading: false }));
				console.log(error?.message);
			}
		};
		if (purchase) initial();
	}, [purchase, epState?.currentPage]);

	return (
		<>
			<div className="holder-table" style={{ marginTop: "3rem" }}>
				<Table
					className="tbl-normal"
					loading={epState?.isLoadingList}
					columns={[
						{
							title: "نام بسته",
							dataIndex: "productname",
							key: "productname",
							width: 150,
						},
						{
							title: "مبلغ",
							dataIndex: "chargamount",
							key: "chargamount",
							width: 150,
						},
						{
							title: "مالیات",
							dataIndex: "tax",
							key: "tax",
							width: 150,
						},
						{
							title: "تاریخ",
							dataIndex: "purchasedate",
							key: "purchasedate",
							width: 150,
						},
						{
							title: "درگاه خرید",
							dataIndex: "paidtype",
							key: "paidtype",
							width: 150,
						},
						{
							title: "کاربر",
							dataIndex: "username",
							key: "username",
							width: 150,
						},
						{
							title: "وضعیت درخواست",
							dataIndex: "state",
							key: "state",
							width: 150,
						},
					]}
					locale={{
						emptyText: (
							<>
								<NotFound text={"رکوردی یافت نشد."} />
							</>
						),
					}}
					scroll={{ y: "100%" }}
					pagination={{
						className: "page-pagination",
						// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
						onChange: (page) => {
							setEPState((ep) => ({ ...ep, currentPage: page }));
						},
						pageSize: 10,
						align: "start",
						current: epState?.currentPage === 0 ? 1 : epState?.currentPage,
						total: epState?.totalRecord,
						showSizeChanger: false,
					}}
					dataSource={epState?.ListPackage.map((item, key) => ({
						key: key,
						productname: item?.productname,
						chargamount: convertCurrencyToToman(item?.chargamount),
						tax: convertCurrencyToToman(item?.tax),
						purchasedate: (
							<>
								{convertToJalaliWithTime(item?.purchasedate)} - {formatDate(new Date(item?.purchasedate))}
							</>
						),
						paidtype: item?.paidtype,
						username: item?.username || "-",
						state: item?.state,
					}))}
				/>
			</div>
		</>
	);
};

export default Packages;
